import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { FontColor } from '@freelancer/ui/text';
import { ViewHeaderType } from '@freelancer/ui/view-header';

@Component({
  standalone: false,
  selector: 'app-navigation-logged-out-home-menu',
  template: `
    <fl-view-header
      class="ViewHeader"
      [type]="ViewHeaderType.CLOSE"
      [heading]="'mobileHeaderTitle'"
      [backButtonHideTablet]="false"
      [logo]="true"
      (close)="handleCloseButtonClick()"
    ></fl-view-header>
    <div class="MainContainer">
      <div
        class="MainContainer-nav"
        flTrackingSection="NavigationSeo"
        [class.IsMainContainerActive]="secondLayer"
      >
        <div class="Header mb-xsmall">
          <p
            class="text-light text-marketing_small font-bold mb-small"
            i18n="Hire Freelancers Title"
          >
            Hire Freelancers
          </p>
        </div>
        <div class="mb-xsmall">
          <app-navigation-menu-nav-item
            i18n-titleLink="By skill navigation item title text"
            titleLink="By skill"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [contentId]="'hireBySkill'"
            [iconName]="'ui-person-brain'"
            [iconArrowColor]="IconColor.LIGHT"
            (clicked)="selectTab($event)"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="By location navigation item title text"
            titleLink="By location"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [contentId]="'location'"
            [iconName]="'ui-person-pin'"
            [iconArrowColor]="IconColor.LIGHT"
            (clicked)="selectTab($event)"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="By category navigation item title text"
            titleLink="By category"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [iconName]="'ui-category'"
            [iconArrow]="false"
            [url]="'/hire'"
          ></app-navigation-menu-nav-item>
        </div>
        <div class="Header mb-xsmall">
          <p
            class="text-light text-marketing_small font-bold mb-small"
            i18n="Find work Title"
          >
            Find work
          </p>
        </div>
        <div class="mb-xsmall">
          <app-navigation-menu-nav-item
            i18n-titleLink="Find Work by skill navigation item title text"
            titleLink="By skill"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [contentId]="'findWorkByskill'"
            [iconName]="'ui-person-brain'"
            [iconArrowColor]="IconColor.LIGHT"
            (clicked)="selectTab($event)"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="By language navigation item title text"
            titleLink="By language"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [contentId]="'language'"
            [iconName]="'ui-language'"
            [iconArrowColor]="IconColor.LIGHT"
            (clicked)="selectTab($event)"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="Featured jobs navigation item title text"
            titleLink="Featured jobs"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [iconName]="'ui-bookmark-v2'"
            [iconArrow]="false"
            [url]="'/jobs?featured=true'"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="Find contests navigation item title text"
            titleLink="Find contests"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [iconName]="'ui-trophy'"
            [iconArrow]="false"
            [url]="'/contest'"
          ></app-navigation-menu-nav-item>
        </div>
        <div class="Header mb-xsmall">
          <p
            class="text-light text-marketing_small font-bold mb-small"
            i18n="Solutions Title"
          >
            Solutions
          </p>
        </div>
        <div class="mb-xsmall">
          <app-navigation-menu-nav-item
            i18n-titleLink="AI for business navigation item title text"
            titleLink="AI for business"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [useIconFont]="false"
            [iconSize]="IconSize.MID"
            [iconName]="'ui-ai'"
            [url]="'/ai'"
            [iconArrow]="false"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="Freelancer products navigation item title text"
            titleLink="Freelancer products"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [contentId]="'products'"
            [iconName]="'ui-bird'"
            [iconSize]="IconSize.MID"
            [useIconFont]="false"
            [iconArrowColor]="IconColor.LIGHT"
            (clicked)="selectTab($event)"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="Freelancer services navigation item title text"
            titleLink="Freelancer services"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [contentId]="'services'"
            [iconName]="'ui-bird'"
            [iconSize]="IconSize.MID"
            [useIconFont]="false"
            [iconArrowColor]="IconColor.LIGHT"
            (clicked)="selectTab($event)"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="Get ideas navigation item title text"
            titleLink="Get ideas"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [contentId]="'getIdeas'"
            [iconName]="'ui-lightbulb'"
            [iconArrowColor]="IconColor.LIGHT"
            (clicked)="selectTab($event)"
          ></app-navigation-menu-nav-item>
          <app-navigation-menu-nav-item
            i18n-titleLink="Resources navigation item title text"
            titleLink="Resources"
            [descriptionColor]="FontColor.LIGHT"
            [isMobile]="true"
            [isLoggedOut]="true"
            [contentId]="'resources'"
            [iconName]="'ui-book'"
            [iconArrowColor]="IconColor.LIGHT"
            (clicked)="selectTab($event)"
          ></app-navigation-menu-nav-item>
        </div>
      </div>
      <div
        class="SidePannel"
        [class.IsActive]="firstLayer || secondLayer"
        [class.IsSecondLayerActive]="secondLayer"
      >
        <div
          flTrackingSection="SkillsSection"
          id="hireBySkill"
        >
          @if (selectedTab === 'hireBySkill') {
            <div class="SubHeader">
              <fl-icon
                class="mr-xsmall"
                flTrackingLabel="GoBackToMainClick"
                [name]="'ui-arrow-left-alt'"
                [clickable]="true"
                [color]="IconColor.LIGHT"
                [size]="IconSize.SMALL"
                (click)="goBackToMain()"
              ></fl-icon>
              <p
                class="text-light text-marketing_small font-bold"
                i18n="Hire freelancers by skill title"
              >
                Hire freelancers by skill
              </p>
            </div>
          }
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'hireBySkill'"
          >
            <app-navigation-logged-out-home-section-hire-freelancers-by-skills
              class="SectionStickyNav"
              (viewSecondLayer)="viewSecondLayer()"
            ></app-navigation-logged-out-home-section-hire-freelancers-by-skills>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="secondLayer && selectedTab === 'hireBySkill'"
          >
            <app-navigation-logged-out-home-section-hire-freelancers-by-skills-list />
          </div>
        </div>
        <div
          flTrackingSection="LocationSection"
          id="location"
        >
          @if (selectedTab === 'location') {
            <div class="SubHeader mb-xxxsmall">
              <fl-icon
                class="mr-xsmall"
                flTrackingLabel="GoBackToMainClick"
                [name]="'ui-arrow-left-alt'"
                [clickable]="true"
                [color]="IconColor.LIGHT"
                [size]="IconSize.SMALL"
                (click)="goBackToMain()"
              ></fl-icon>
              <p
                class="text-light text-marketing_small font-bold"
                i18n="Hire freelancers by location title"
              >
                Hire freelancers by location
              </p>
            </div>
          }
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'location'"
          >
            <app-navigation-logged-out-home-section-hire-freelancers-by-location />
          </div>
        </div>
        <div
          flTrackingSection="WorkSkillsSection"
          id="findWorkByskill"
        >
          @if (selectedTab === 'findWorkByskill') {
            <div class="SubHeader">
              <fl-icon
                class="mr-xsmall"
                flTrackingLabel="GoBackToMainClick"
                [name]="'ui-arrow-left-alt'"
                [clickable]="true"
                [color]="IconColor.LIGHT"
                [size]="IconSize.SMALL"
                (click)="goBackToMain()"
              ></fl-icon>
              <p
                class="text-light text-marketing_small font-bold"
                i18n="Find work by skill title"
              >
                Find work by skill
              </p>
            </div>
          }
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'findWorkByskill'"
          >
            <app-navigation-logged-out-home-section-find-work-by-skills
              (viewSecondLayer)="viewSecondLayer()"
            ></app-navigation-logged-out-home-section-find-work-by-skills>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="secondLayer && selectedTab === 'findWorkByskill'"
          >
            <app-navigation-logged-out-home-section-find-work-by-skills-list />
          </div>
        </div>
        <div
          flTrackingSection="LanguageSection"
          id="language"
        >
          @if (selectedTab === 'language') {
            <div class="SubHeader">
              <fl-icon
                class="mr-xsmall"
                flTrackingLabel="GoBackToMainClick"
                [name]="'ui-arrow-left-alt'"
                [clickable]="true"
                [color]="IconColor.LIGHT"
                [size]="IconSize.SMALL"
                (click)="goBackToMain()"
              ></fl-icon>
              <p
                class="text-light text-marketing_small font-bold"
                i18n="Find work by language title"
              >
                Find work by language
              </p>
            </div>
          }
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'language'"
          >
            <app-navigation-logged-out-home-section-find-work-by-languages />
          </div>
        </div>
        <div
          flTrackingSection="ProductSection"
          id="products"
        >
          @if (selectedTab === 'products') {
            <div class="SubHeader">
              <fl-icon
                class="mr-xsmall"
                flTrackingLabel="GoBackToMainClick"
                [name]="'ui-arrow-left-alt'"
                [clickable]="true"
                [color]="IconColor.LIGHT"
                [size]="IconSize.SMALL"
                (click)="goBackToMain()"
              ></fl-icon>
              <p
                class="text-light text-marketing_small font-bold"
                i18n="Freelancer products title"
              >
                Freelancer products
              </p>
            </div>
          }
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'products'"
          >
            <app-navigation-logged-out-home-section-products />
          </div>
        </div>
        <div
          flTrackingSection="ServicesSection"
          id="services"
        >
          @if (selectedTab === 'services') {
            <div class="SubHeader">
              <fl-icon
                class="mr-xsmall"
                flTrackingLabel="GoBackToMainClick"
                [name]="'ui-arrow-left-alt'"
                [clickable]="true"
                [color]="IconColor.LIGHT"
                [size]="IconSize.SMALL"
                (click)="goBackToMain()"
              ></fl-icon>
              <p
                class="text-light text-marketing_small font-bold"
                i18n="Freelancer services title"
              >
                Freelancer services
              </p>
            </div>
          }
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'services'"
          >
            <app-navigation-logged-out-home-section-services />
          </div>
        </div>
        <div
          flTrackingSection="GetIdeasSection"
          id="getIdeas"
        >
          @if (selectedTab === 'getIdeas') {
            <div class="SubHeader">
              <fl-icon
                class="mr-xsmall"
                flTrackingLabel="GoBackToMainClick"
                [name]="'ui-arrow-left-alt'"
                [clickable]="true"
                [color]="IconColor.LIGHT"
                [size]="IconSize.SMALL"
                (click)="goBackToMain()"
              ></fl-icon>
              <p
                class="text-light text-marketing_small font-bold"
                i18n="Get ideas title"
              >
                Get ideas
              </p>
            </div>
          }
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'getIdeas'"
          >
            <app-navigation-logged-out-home-section-get-ideas />
          </div>
        </div>
        <div
          flTrackingSection="ResourcesSection"
          id="resources"
        >
          @if (selectedTab === 'resources') {
            <div class="SubHeader">
              <fl-icon
                class="mr-xsmall"
                flTrackingLabel="GoBackToMainClick"
                [name]="'ui-arrow-left-alt'"
                [clickable]="true"
                [color]="IconColor.LIGHT"
                [size]="IconSize.SMALL"
                (click)="goBackToMain()"
              ></fl-icon>
              <p
                class="text-light text-marketing_small font-bold"
                i18n="Resources title"
              >
                Resources
              </p>
            </div>
          }
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'resources'"
          >
            <app-navigation-logged-out-home-section-resources />
          </div>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-logged-out-home-menu.component.scss'],
})
export class NavigationLoggedOutHomeMenuComponent {
  FontColor = FontColor;
  IconColor = IconColor;
  IconSize = IconSize;
  ViewHeaderType = ViewHeaderType;

  selectedTab?: string | undefined;
  firstLayer = false;
  secondLayer = false;

  constructor(private location: Location) {}

  selectTab(tab: string | undefined): void {
    this.selectedTab = tab;
    this.firstLayer = true;
  }

  goBackToMain(): void {
    if (this.firstLayer) {
      this.selectedTab = undefined;
      this.firstLayer = false;
    } else if (this.secondLayer) {
      this.firstLayer = true;
      this.secondLayer = false;
    }
  }

  viewSecondLayer(): void {
    this.firstLayer = false;
    this.secondLayer = true;
  }

  handleCloseButtonClick(): void {
    this.location.back();
  }
}
